import { isEmpty } from 'rambda';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import type { SearchGroupMember } from '@/hooks/search/use-search-group-members';
import ROUTES from '@/routes';
import cn from '@/utils/merge-class-names';
import { generateSessionKey } from '@/utils/session';
import SearchListItem from './search-list-item';

interface Props {
  groups: SearchGroupMember[];
  keyword?: string;
  className?: string;
}

export default function SearchGroupResultList({ className, keyword = '', groups }: Props) {
  const { t } = useTranslation();

  if (isEmpty(groups)) return null;

  return (
    <div className={cn('group/group', className)}>
      <h4 className='flex h-6 group-first/group:mt-1 mb-2 items-center px-5 text-body1 font-bold'>
        {t('search.groups')}
      </h4>

      {groups.map(({ GroupID, GroupImg, GroupName, Users }) => (
        <Link
          key={generateSessionKey('group', GroupID)}
          to={ROUTES.MESSAGES.GROUPS.$buildPath({ params: { id: GroupID } })}
          state={ROUTES.MESSAGES.GROUPS.$buildState({ state: { from: 'search' } })}>
          <SearchListItem
            avatarImageUrl={GroupImg}
            highlight={keyword}
            highlightField='description'
            title={GroupName}
            description={
              !isEmpty(Users) ? t('search.include', { names: Users.map((m) => m.MatchedName).join(', ') }) : ''
            }
          />
        </Link>
      ))}
    </div>
  );
}
